import { render, staticRenderFns } from "./TS05.vue?vue&type=template&id=5c218eb9&"
import script from "./TS05.vue?vue&type=script&lang=js&"
export * from "./TS05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports